module.exports = __webpack_public_path__ + "static/media/file_download.bdbb8b43.svg";